import { ActionIcon, Box, Divider, Grid, Group, Paper, Text, UnstyledButton, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import PhonesPage from '../components/integrations/phones';
import { useAuth } from '../contexts/auth.context';
import { useLanguage } from '../contexts/language.context';
import WhitelabelPage from './appearance';
import AutomationsPage from './automations';
import BillingPage from './billing';
import CalendarsPage from './calendars';
import FieldsPage from './fields';
import FilesPage from './files';
import IntegrationsPage from './integrations';
import OverviewPage from './overview';
import PreferencesPage from './preferences';
import ProfilePage from './profile';
import TagsPage from './tags';
import UsersPage from './users';
// import { Channels, Flows } from '../components';

export default function SettingsPage() {
    const { role, planData } = useAuth();
    const { str } = useLanguage();

    const isMobile = useMediaQuery('(max-width: 900px)');

    const [selected, setSelected] = React.useState(isMobile ? null : "profile");

    const { hash } = useLocation();
    const theme = useMantineTheme();
    const navigate = useNavigate();

    const options = [
        { key: "profile", title: str("PROFILE.TITLE") },
        ["Owner", "Admin"].includes(role?.profile?.title) && {key: "brand", title: str("PROFILE.BRAND_SETTINGS"), allowed: planData?.active },
        ["Owner", "Admin"].includes(role?.profile?.title) && { key: "billing", title: str("BILLING.TITLE") },
        ["Owner", "Admin"].includes(role?.profile?.title) && { key: "users", title: str("TEAM.TITLE") },
        ["Owner", "Admin"].includes(role?.profile?.title) && { key: "tags", title: str("TAGS.TITLE") },
        ["Owner", "Admin"].includes(role?.profile?.title) && { key: "fields", title: str("FIELDS.TITLE") },
        ["Owner", "Admin"].includes(role?.profile?.title) && { key: "integrations", title: str("INTEGRATIONS.TITLE") },
        // ["Owner", "Admin"].includes(role?.profile?.title) && {key: "automations", title: "Automations", allowed: planData?.active },
        // ["Owner", "Admin"].includes(role?.profile?.title) && {key: "phones", title: "Phones" },
        // ["Owner", "Admin"].includes(role?.profile?.title) && {key: "whitelabel", title: "Whitelabel Client Portal", allowed: planData?.active },

        // role && {key: "files", title: "Arquivos" },
        // role && {key: "preferences", title: "Preferências" },
        // role && {key: "users", title: "Usuários", buttons: [
        //     { leftSection: <FaPlus />, title: "Usuário", onClick: () => {setOpenUsers(true)} }
        // ]},
        // role && {key: "teams", title: "Equipes", buttons: [
        //     { leftSection: <FaPlus />, title: "Equipe", onClick: () => {setOpenTeams(true)} }
        // ]},
        // role && {key: "financeiro", title: "Financeiro" },
    ].filter(nn => nn)

    React.useEffect(() => {
        if (hash) {
            setSelected(hash.split("#")[1]);
        } else {
            setSelected(isMobile ? null : "profile");
        };
    }, [hash, isMobile]);

    React.useEffect(() => {
        if (selected && !options.find(opt => opt.key === selected)) {
            setSelected("profile");
        }
    }, [selected, isMobile]);

    return <>
        <Paper shadow='xs' style={{ padding: 0 }}>
            <Grid gutter={0}>
                {(!isMobile || !selected) && <Grid.Col span={{ base: 12, md: 4 }} style={{ minHeight: '70vh' }}>
                    <Box style={{ height: '100%' }}>
                        {options.map(({ key, title }) => (
                            <UnstyledButton style={{ width: '100%' }} onClick={() => {
                                // if(!allowed) notifications.show({
                                //     title: "Payment required",
                                //     message: "Check for your billing settings, there is one payment subscription that failed, change your payment method and try again.",
                                //     color: "yellow"
                                // })
                                navigate(`/settings#${key}`);
                            }}>
                                <Group
                                    style={{ borderRight: `7px solid ${selected === key ? "black" : "transparent"}` }}
                                    p="xl"
                                >
                                    <Box style={{ flex: 1 }}>
                                        <Text size="md" fw="bold" c="gray.0">{title}</Text>
                                    </Box>
                                </Group>
                                <Divider />
                            </UnstyledButton>
                        ))}
                    </Box>
                </Grid.Col>}
                {(!isMobile || selected) && <Grid.Col span={{ base: 12, md: 8 }} style={{ minHeight: '70vh', backgroundColor: theme.colors.dark[9] }}>
                    {isMobile && <Group p="md">
                        <ActionIcon size="xl" onClick={() => navigate("/settings")}><FaArrowLeft /></ActionIcon>
                    </Group>}
                    <Box p="md" pr="xl">
                        {selected === "profile" && <ProfilePage />}
                        {selected === "brand" && <ProfilePage company />}
                        {selected === "overview" && <OverviewPage />}
                        {selected === "calendars" && <CalendarsPage />}
                        {selected === "automations" && <AutomationsPage />}
                        {selected === "fields" && <FieldsPage />}
                        {selected === "tags" && <TagsPage />}
                        {selected === "billing" && <BillingPage />}
                        {selected === "phones" && <PhonesPage />}
                        {selected === "preferences" && <PreferencesPage />}
                        {selected === "users" && <UsersPage />}
                        {selected === "files" && <FilesPage />}
                        {selected === "integrations" && <IntegrationsPage />}
                        {selected === "whitelabel" && <WhitelabelPage />}
                    </Box>
                </Grid.Col>}
            </Grid>
        </Paper>

    </>

}
